export default __webpack_public_path__ + "static/media/gfbot.8a876455.PNG";